import React, { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Reveal } from "@/components/Reveal";
import { Star } from "lucide-react";

// Genuine Google reviews (curated in admin, or synced via Places API). No fake data.
export function GoogleReviews({ heading = "What our travellers say" }) {
  const [data, setData] = useState({ reviews: [], google_configured: false, place_url: "" });

  useEffect(() => {
    api.get("/reviews", { params: { published: true } }).then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data.reviews || data.reviews.length === 0) return null;

  return (
    <section className="bg-[#FFF7EC] py-20 lg:py-28" data-testid="google-reviews">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div>
            <p className="eyebrow flex items-center gap-2">
              <img src="https://www.gstatic.com/images/branding/product/1x/googleg_48dp.png" alt="Google" className="h-4 w-4" /> Reviews from Google
            </p>
            <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-tight mt-3 text-[#2A1808]">{heading}</h2>
          </div>
          {data.place_url && (
            <a href={data.place_url} target="_blank" rel="noreferrer" className="text-sm font-semibold text-[#F49E1A] link-underline">See all on Google →</a>
          )}
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {data.reviews.slice(0, 6).map((r, i) => (
            <Reveal key={r.id} delay={(i % 3) * 70}>
              <div className="h-full rounded-md border border-[#553204]/10 bg-[#FFFBF5] p-6 flex flex-col" data-testid={`review-${r.id}`}>
                <div className="flex items-center gap-3">
                  {r.profile_photo
                    ? <img src={r.profile_photo} alt={r.author} className="h-10 w-10 rounded-full object-cover" referrerPolicy="no-referrer" />
                    : <span className="h-10 w-10 rounded-full bg-[#553204]/10 flex items-center justify-center font-display text-lg text-[#553204]">{(r.author || "?")[0]}</span>}
                  <div>
                    <p className="font-semibold text-[#2A1808] text-sm">{r.author}</p>
                    <p className="text-xs text-[#8A6B47]">{r.date}</p>
                  </div>
                  <img src="https://www.gstatic.com/images/branding/product/1x/googleg_48dp.png" alt="Google" className="h-5 w-5 ml-auto" />
                </div>
                <div className="flex gap-0.5 mt-3">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star key={`star-${k}`} size={15} className={k < (r.rating || 5) ? "fill-[#FBBC04] text-[#FBBC04]" : "text-[#553204]/20"} />
                  ))}
                </div>
                <p className="mt-3 text-sm text-[#553204] leading-relaxed line-clamp-3 flex-1">{r.text}</p>
                {r.review_url && <a href={r.review_url} target="_blank" rel="noreferrer" className="mt-3 text-xs text-[#8A6B47] hover:text-[#F49E1A]">View on Google</a>}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
